import { useGetUserMe } from '@/api/REST/userMe';
import { isTest } from '@/legacy/utils/env';

export const useHasNewSearchUI = () => {
  const { hasLegacyBillingPlan } = useGetUserMe();

  if (hasLegacyBillingPlan || isTest) {
    return false;
  }

  return true;
};
